export default "__VITE_ASSET__CayRl5Hn__"